export default "/signup/_next/static/chunks/fonts/LyftProUI-Bold-0be33c81ac715143f8577cfdaf8ff72b.otf";